import { InjectionToken } from '@angular/core';

export interface EnvironmentToken {
  production: boolean;
  deployMode: 'onpremise' | 'saas';
  customer: string;
  customerCategory: string;
}

export const ENVIRONMENT_TOKEN = new InjectionToken<EnvironmentToken>('ENVIRONMENT');
